<div
  *ngIf="!props.hidden"
  [class.has-error]="showError"
  [ngClass]="props.wrapperClass"
  class="field-wrapper"
>
  <div>
    <label
      *ngIf="props.label && props.hideLabel !== true"
      [attr.for]="id"
      class="field-label"
    >
      {{ props.label
      }}<span
        *ngIf="(!disabled && props.required && props.hideMandatoryMarker !== true) || props.alwaysShowMandatoryMarker"
        class="text-primary font-bold"
        >*</span
      >
    </label>

    <mat-icon
      #matTooltip="matTooltip"
      (click)="matTooltip.show()"
      *ngIf="props.tooltip && !disabled"
      [matTooltip]="props.tooltip"
      class="align-text-bottom `ml-1"
      matTooltipClass="whitespace-pre-wrap text-inherit"
      matTooltipPosition="above"
    >
      information
    </mat-icon>
  </div>

  <div
    *ngIf="props.description"
    [innerHTML]="props.description | safeSource: 'html'"
    class="mt-2"
  ></div>

  <ng-template #fieldComponent></ng-template>

  <formly-validation-message
    *ngIf="showError"
    [field]="field"
    class="block text-xs text-primary mt-1"
  ></formly-validation-message>

  <small
    *ngIf="(!disabled || props.alwaysShowHint) && props.hint"
    [innerHTML]="props.hint | safeSource: 'html'"
    class="block text-sm text-dark/70 mt-1"
  >
  </small>
</div>
